import { z } from 'zod';

import { numericId, requiredDate } from '../../utils/validation';

import { FIELD_LABELS } from './lab-constants';

/**
 * Validation for the lab 2 start exception form. `eventProductId` is
 * resolved from the event lookup and can be the literal 'Not Found'.
 */
export const labStartSchema = z.object({
    eventProductId: numericId('Event Product Id'),
    lab_2_date: requiredDate(FIELD_LABELS.lab_2_date),
});
